import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { CreditsProvider } from './contexts/CreditsContext';
import { AuthModalProvider } from './contexts/AuthModalContext';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CookieConsentRoot from './components/cookie/CookieConsentRoot';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <CreditsProvider>
          <AuthModalProvider>
          <App />
          <CookieConsentRoot />
          </AuthModalProvider>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            toastStyle={{
              backgroundColor: '#FFD024',
              color: '#2C2C2C',
              border: '2px solid #2C2C2C',
              borderRadius: '10px',
              fontWeight: 'bold'
            }}
          />
        </CreditsProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);